const bundleDropDown = (() => {
  let self = {
    init: () => {
      const bundleProducts = document.querySelector('.bundleProducts');
      if (!bundleProducts) return;
      const mainBundleItem = bundleProducts.querySelector('.mainBundle .bundleProductItem');
      if (!mainBundleItem) return;
      mainBundleItem.addEventListener('click', (e) => {
        bundleProducts.classList.toggle('open');
      });
      window.addEventListener('click', (e) => {
        if (bundleProducts.classList.contains('open') && !bundleProducts.contains(e.target)) {
          bundleProducts.classList.remove('open');
        }
      });
    },
  };
  return self;
})();

document.addEventListener('DOMContentLoaded', () => {
  let pdp__bundleDropDown = document.querySelector('.pdp__bundleDropDown');
  if (pdp__bundleDropDown) bundleDropDown.init();
});
